import React from "react";

const PageStarter = ({
  pageName,
  btnLabel,
  searchPlaceHolder,
  onClickAdd,
  onClickSearch,
  handleKeyPress,
  filters,
  setFilters,
  searchFilterApplied,
  isReload,
}) => {
  return (
    <div className="page-starter-container">
      <div
        className="page-label flex-start"
        style={{
          columnGap: "1rem",
        }}>
        <h1 className="page-name">{pageName}</h1>
        {isReload && (
          <button
            variant="dark"
            type="button"
            onClick={isReload}
            style={{
              width: "30px",
              height: "30px",
              borderRadius: "50%",
              border: "none",
              backgroundColor: "#000",
              cursor: "pointer",
              color: "#fff",
            }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-arrow-clockwise"
              viewBox="0 0 16 16"
              style={{
                color: "#fff",
                fill: "#fff",
              }}>
              <path
                fillRule="evenodd"
                d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
              />
              <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
            </svg>
          </button>
        )}
      </div>

      <div className="page-filter-btns flex-end">
        {onClickSearch && (
          <div
            className={`inputCommonWrapper flexSpacebetween searchBarContainer ${
              searchFilterApplied ? "redBorderRedText" : ""
            }`}>
            <input
              type="search"
              className="input"
              placeholder={`Search ${searchPlaceHolder}`}
              value={filters?.searchString}
              onChange={(e) =>
                setFilters({
                  ...filters,
                  searchString: e.target.value,
                })
              }
              onKeyDown={handleKeyPress}
            />
            <button
              type="button"
              className="button btn btn-danger"
              onClick={onClickSearch}>
              {/* search */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-search"
                viewBox="0 0 16 16">
                <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
              </svg>
            </button>
          </div>
        )}

        {btnLabel ? (
          <button
            type="button"
            className="btn btn-danger starter-page-add-btn"
            onClick={onClickAdd}>
            {btnLabel}
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default PageStarter;